import { render, staticRenderFns } from "./ChannelCardGroupGrid.vue?vue&type=template&id=6a9d00f7&scoped=true"
import script from "./ChannelCardGroupGrid.vue?vue&type=script&lang=js"
export * from "./ChannelCardGroupGrid.vue?vue&type=script&lang=js"
import style0 from "./ChannelCardGroupGrid.vue?vue&type=style&index=0&id=6a9d00f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d00f7",
  null
  
)

export default component.exports